import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-voicelist',
  templateUrl: './voicelist.component.html',
  styleUrls: ['./voicelist.component.css']
})
export class VoicelistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
